"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSInternationalcallsComponent = void 0;
const helper_service_1 = require("../services/helper.service");
const router_1 = require("@angular/router");
const event_manager_service_1 = require("../services/event-manager.service");
class CSInternationalcallsComponent {
    constructor(helperServive, router, eventservice) {
        this.helperServive = helperServive;
        this.router = router;
        this.eventservice = eventservice;
    }
    navigate(type) {
        this.eventservice.event.subscribe((value) => {
            this.accountType = value;
        });
        if (this.accountType === 'POSTPAID') {
            if (type === 'calling') {
                this.router.navigate(['/wireless/international-call'], { queryParams: { section: type } });
            }
            else if (type === 'travel') {
                this.router.navigate(['/wireless/international-call'], { queryParams: { section: type } });
            }
            else if (type === 'texting') {
                this.router.navigate(['/wireless/international-call'], { queryParams: { section: type } });
            }
            else {
                this.router.navigate(['/wireless/international-call'], { queryParams: {} });
            }
        }
        else {
            if (type === 'calling') {
                this.router.navigate(['/prepaid/international-call'], { queryParams: { section: type } });
            }
            else if (type === 'travel') {
                this.router.navigate(['/prepaid/international-call'], { queryParams: { section: type } });
            }
            else if (type === 'texting') {
                this.router.navigate(['/prepaid/international-call'], { queryParams: { section: type } });
            }
            else {
                this.router.navigate(['/wireless/international-call'], { queryParams: {} });
            }
        }
    }
}
exports.CSInternationalcallsComponent = CSInternationalcallsComponent;
//# sourceMappingURL=internationalcalls.component.js.map